<template>
    <div class="bg-gray relative z-0">
        <div class="page-container " :class="{'has-breadcrumb': profile.isSharpAdmin()}">
            <div class="px-8 md:px-5 py-5 " v-if="profile.isSharpAdmin()">
                <breadcrumb></breadcrumb>
            </div>
            <div class="px-8 md:px-5 py-5 ">
                <h1 class="mb-6">
                    Clients
                </h1>
                <client-grid></client-grid>
            </div>
        </div>
    </div>
</template>

<script charset="utf-8">
    import ClientGrid from './includes/ClientGrid.vue';
    import Breadcrumb from './includes/Breadcrumb.vue';
    import Vuex from 'vuex';

    export default {
        components: {
            ClientGrid,
            Breadcrumb
        },

        created: function () {
            this.setPaths([
                {
                    text: 'Sharp Admin',
                    name: 'adminClient',
                    isText: true
                }
            ]);
        },

        computed: {
            ...Vuex.mapGetters('profile', {
                profile: 'profile'
            }),
        },

        methods: {
            ...Vuex.mapMutations('layout', {
                setPaths: 'setPaths'
            }),
        }
    }
</script>
